import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: ReactNode;
  /** Describe the job, not the implementation. */
  subtitle?: ReactNode;
  /** At most one `primary` button. */
  actions?: ReactNode;
}

export function PageHeader({ title, subtitle, actions }: PageHeaderProps) {
  return (
    <header className="ui-page-header">
      <div>
        <h1>{title}</h1>
        {subtitle && <p className="ui-page-subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="ui-page-actions">{actions}</div>}
    </header>
  );
}
